// Celda de promos de la tabla de «Teléfono» con las burbujas del wizard: la primera completa y
// «+N» con la lista entera en el tooltip.
import { Tag } from 'lucide-react';
import { Bubble } from '@/domains/sales/wizard/components/BenefitRow';
import { StatusPill } from '@/shared/patterns/Pills';
import { UNDETAILED_PROMOTION_LABEL } from '@/shared/patterns/Promotions';
import { promotionBubbles, type PhonePromotions } from '../lib/phonePromotions';

const DASH = '—';

export function PhonePromotionsCell({ promotions }: { promotions: PhonePromotions }) {
    const bubbles = promotionBubbles(promotions);
    if (bubbles.length === 0) {
        return promotions.undetailed ? (
            <Bubble bubble={{ key: 'undetailed', label: UNDETAILED_PROMOTION_LABEL, icon: Tag }} />
        ) : (
            <span className="text-muted-foreground">{DASH}</span>
        );
    }
    const [first, ...rest] = bubbles;
    const all = bubbles.map((bubble) => bubble.title ?? bubble.label).join('\n');
    return (
        <span className="flex min-w-0 items-center gap-1" title={all}>
            <span className="min-w-0">
                <Bubble bubble={first} />
            </span>
            {rest.length === 0 ? null : (
                <StatusPill
                    tone="neutral"
                    className="h-6 flex-none px-2 text-[11px] font-bold"
                    title={`${String(rest.length)} promociones más`}
                >
                    <span aria-label={`${String(rest.length)} promociones más`}>
                        +{rest.length}
                    </span>
                </StatusPill>
            )}
        </span>
    );
}
